var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fix-switch",class:{
        'fix-switch--active': _vm.isFixed,
        'fix-switch--placed': _vm.isDisabled && !_vm.isFixed,
    },attrs:{"disabled":_vm.isDisabled,"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('setFixed')}}},[_vm._v(" fix ")])}
var staticRenderFns = []

export { render, staticRenderFns }